import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { refreshToken, SignOutApi } from "../../utils/API";
import { async } from "q";
import { any } from "prop-types";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "500px",
    width: "100%",
    padding: "50px",
    fontSize: "10px",
    position: "absolute",
  },
};

export const TimeoutWarningModal = ({
  isOpen,
  onRequestClose,
  setUser,
}: any) => {
  const [isWarningModalOpen, setWarningModalOpen] = useState(false);
  let idleLogout = 1000 * 60 * 2;
  const navigate = useNavigate();
  const onClickNavigate = (page: string) => {
    navigate(`${page}`);
  };

  const onLogOffCall = async () => {
    let signOutApiRes: any = await SignOutApi();
    window.localStorage.clear();
    onClickNavigate("/signin");
  };

  return (
    <div>
      <Modal
        isOpen={isOpen}
        styles={customStyles}
        centered
        autoFocus={true}
        id="sessionModal"
        contentLabel="Session Modal"
        backdrop="static"
      >
        <ModalHeader>Session Timeout</ModalHeader>
        <ModalBody>
          <div>
            your session will expire in {idleLogout / 60 / 1000} minutes. Do you
            want to extend the session?
          </div>
        </ModalBody>
        <br />
        <ModalFooter>
          <button onClick={onLogOffCall}>Log off</button>
          <button onClick={onRequestClose}>Stay Logged In</button>
        </ModalFooter>
      </Modal>
    </div>
  );
};
